var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCuratedWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58153 9.75376H3.15069C3.15069 9.75376 2.81545 9.70726 2.5973 9.42174C2.41787 9.1869 2.32697 8.74495 2.48663 8.42569C2.8404 7.71828 3.26139 7.983 3.37204 7.76166C3.48268 7.54031 3.64861 6.43359 4.81077 6.43359C5.97294 6.43359 6.02811 7.4369 6.24948 7.65099C6.43056 7.82611 7.21343 7.76166 7.24556 8.75771C7.27209 9.58006 6.58153 9.75376 6.58153 9.75376Z",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7392 11.8592H12.3084C12.3084 11.8592 11.9732 11.8127 11.755 11.5272C11.5756 11.2924 11.4847 10.8504 11.6443 10.5312C11.9981 9.82375 12.4191 10.0885 12.5298 9.86713C12.6404 9.64578 12.8063 8.53906 13.9685 8.53906C15.1307 8.53906 15.1858 9.54237 15.4072 9.75646C15.5883 9.93157 16.3711 9.86713 16.4033 10.8632C16.4298 11.6855 15.7392 11.8592 15.7392 11.8592Z",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6603 11.8577H2.81841H1.5L3.90405 9.5M13.4039 9L8.90538 4L5.90386 7",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64233 5.96412C7.64233 5.96412 8.29714 6.61893 8.95195 6.61893C9.60676 6.61893 10.4041 5.5 10.4041 5.5",
    stroke: "white",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuratedWhite);
export default __webpack_public_path__ + "static/media/Curated_white.87c1f9f4477e8bab502b5670d45a4790.svg";
export { ForwardRef as ReactComponent };